/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/scripts.js":
/*!******************************!*\
  !*** ./resources/scripts.js ***!
  \******************************/
/***/ (() => {

document.addEventListener('DOMContentLoaded', function () {
  console.log('Variant gallery script (fixed) initialized');
  var fadeDuration = 400; // ms

  var fadeOut = function fadeOut(el) {
    el.style.transition = "opacity ".concat(fadeDuration, "ms ease");
    el.style.opacity = '0';
    el.dataset.fading = 'out';
    setTimeout(function () {
      if (el.dataset.fading === 'out') {
        el.style.display = 'none';
        el.dataset.fading = '';
      }
    }, fadeDuration);
  };
  var fadeIn = function fadeIn(el) {
    el.style.transition = 'none';
    el.style.display = '';
    el.style.opacity = '0';
    el.offsetHeight; // force reflow
    el.style.transition = "opacity ".concat(fadeDuration, "ms ease");
    requestAnimationFrame(function () {
      el.style.opacity = '1';
    });
  };
  function firstPageDawnGalleryNoFlicker(variantName) {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var slides = Array.from(gallery.querySelectorAll('.product__media-item'));
    var thumbs = Array.from(gallery.querySelectorAll('.thumbnail-list__item'));
    var firstVisibleSlide = null;

    // Hide all slides first
    slides.forEach(function (slide) {
      //slide.style.transition = 'none';
      //slide.style.display = 'none';
      //slide.style.opacity = '0';
      slide.classList.remove('is-active');
    });

    // Show only slides matching variantName
    slides.forEach(function (slide) {
      console.log('doing nothing now');
      var img = slide.querySelector('img');
      if (!img) return;
      var matches = img.alt.trim().toLowerCase().includes(variantName.toLowerCase());
      if (matches && !firstVisibleSlide) {
        fadeIn(slide);
        slide.classList.add('is-active');
        firstVisibleSlide = slide;
      } else if (matches) {
        //slide.style.display = 'none';
      }
    });

    // Show only matching thumbnails
    thumbs.forEach(function (thumb) {
      var img = thumb.querySelector('img');
      if (!img) return;
      var matches = img.alt.trim().toLowerCase().includes(variantName.toLowerCase());
      if (matches) {
        thumb.style.display = '';
        thumb.style.opacity = '1';
        thumb.classList.add('is-active');
      } else {
        thumb.style.display = 'none';
        thumb.style.opacity = '0';
        thumb.classList.remove('is-active');
      }
    });
    console.log("Gallery + thumbnails updated for variant: ".concat(variantName));
  }
  function updateDawnGalleryNoFlicker(variantName) {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var slides = Array.from(gallery.querySelectorAll('.product__media-item'));
    var thumbs = Array.from(gallery.querySelectorAll('.thumbnail-list__item'));
    var firstVisibleSlide = null;

    // Hide all slides first
    slides.forEach(function (slide) {
      // slide.style.transition = 'none';
      // slide.style.display = 'none';
      // slide.style.opacity = '0';
      slide.classList.remove('is-active');
    });

    // Show only slides matching variantName
    slides.forEach(function (slide) {
      console.log('doing nothing now');
      // const img = slide.querySelector('img');
      // if (!img) return;

      // const matches = img.alt.trim().toLowerCase().includes(variantName.toLowerCase());
      // if (matches && !firstVisibleSlide) {
      //   fadeIn(slide);
      //   slide.classList.add('is-active');
      //   firstVisibleSlide = slide;
      // } else if (matches) {
      //   //slide.style.display = 'none';
      // }
    });

    // Show only matching thumbnails
    thumbs.forEach(function (thumb) {
      var img = thumb.querySelector('img');
      if (!img) return;
      var matches = img.alt.trim().toLowerCase().includes(variantName.toLowerCase());
      if (matches) {
        thumb.style.display = '';
        thumb.style.opacity = '1';
        thumb.classList.add('is-active');
      } else {
        thumb.style.display = 'none';
        thumb.style.opacity = '0';
        thumb.classList.remove('is-active');
      }
    });
    console.log("Gallery + thumbnails updated for variant: ".concat(variantName));
  }
  function initCurrentVariant() {
    var activeSwatch = document.querySelector('input.swatch-input__input:checked');
    var variantName = activeSwatch ? activeSwatch.value.trim() : null;
    if (!variantName) {
      var select = document.querySelector('form[action*="/cart/add"] select[name="id"]');
      if (select && select.selectedOptions.length) {
        variantName = select.selectedOptions[0].text.trim();
      }
    }
    if (!variantName) {
      var firstSwatch = document.querySelector('input.swatch-input__input');
      if (firstSwatch) variantName = firstSwatch.value.trim();
    }
    if (variantName) {
      firstPageDawnGalleryNoFlicker(variantName);
    }
    var gallery = document.querySelector('media-gallery');
    if (gallery) gallery.classList.add('media-gallery--ready');
  }
  document.body.addEventListener('click', function (event) {
    var target = event.target;
    if (target.matches('input.swatch-input__input')) {
      var variantName = target.value.trim();
      updateDawnGalleryNoFlicker(variantName);
    }
  });
  initCurrentVariant();
});

/***/ }),

/***/ "./resources/style.scss":
/*!******************************!*\
  !*** ./resources/style.scss ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/scripts": 0,
/******/ 			"assets/style": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkbeyond_books_theme"] = self["webpackChunkbeyond_books_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/style"], () => (__webpack_require__("./resources/scripts.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/style"], () => (__webpack_require__("./resources/style.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;